import styled from "styled-components";

export const Style = styled.div`
  @font-face {
    font-family: "DS-DIGI";
    src: url("${process.env.PUBLIC_URL}/knockknock/font/DS-DIGI.ttf")
      format("truetype");
    font-weight: 400;
  }

  h1 {
    font-size: 150px;
    line-height: 120px;
    color: #c1c1c1;
    font-family: "DS-DIGI";
  }
  h2 {
    font-size: 64px;
    line-height: 64px;
    color: #c1c1c1;

    font-family: "DS-DIGI";
  }
  h3 {
    font-size: 50px;
    line-height: 50px;
    color: #c1c1c1;

    font-family: "DS-DIGI";
  }
  h4 {
    font-size: 40px;
    line-height: 40px;
    color: #c1c1c1;

    font-family: "DS-DIGI";
  }

  .row {
    margin-top: 30px;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .knockContainer {
    flex: 1;
    min-height: 100vh;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #000000;
    padding: 0 0 24% 0;
    justify-content: space-between;
    gap: 30px;
  }
  .header {
    width: 100%;
    display: flex;
    padding: 20px;
    img {
      width: 80px;
    }
  }
  button {
    position: relative;
    display: flex;
    align-items: center;
    padding: 10px 40px;
    background: #000;
    border: 2px solid #5a5a5a;
    border-radius: 100px;
    color: #c1c1c1;
    text-align: center;
    font-size: 24px;
    line-height: 36px;
    font-weight: 300;
    cursor: pointer;
    gap: 8px;
    z-index: 1;
  }
  button.dining {
    padding: 18px 60px;
    border: none;
    font-size: 28px;
    line-height: 42px;
  }
  button:before {
    content: "";
    position: absolute;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    border-radius: 100px;
    background: linear-gradient(90deg, #797979 0%, #232323 100%);
    z-index: -1;
  }
  button::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: inherit;
    border-radius: 100px;
    z-index: -1;
  }

  button.confirm {
    width: 100px;
    padding: 10px 0;
    font-size: 18px;
    line-height: 26px;
    justify-content: center;
  }
  button.confirm.ok {
    background: #ffffff99;
    border: none;
    color: #000000;
  }
  button.delete {
    padding: 10px;
  }

  .body {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    margin-top: 20%;
    .clock {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 30px;
    }
  }

  .timeWrap {
    display: flex;
    align-items: flex-end;
    h1 {
      text-align: right;
    }
    h1.time {
      width: 75px;
    }
    h3 {
      margin-left: 10px;
    }
  }

  .settingWrap {
    display: flex;
    flex-direction: column;
    gap: 20px;
    .setting {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 20px;
      background: #ffffff10;
      border-radius: 20px;
      gap: 20px;
      h2 {
        width: 200px;
        text-align: right;
        span {
          font-size: 40px;
          line-height: 40px;
          color: #c1c1c1;
        }
      }
    }
    .buttonWrap {
      display: flex;
      justify-content: center;
      gap: 20px;
      button {
        margin: 0;
      }
    }
    .buttonWrap.volume {
      flex-direction: column;
      border: 1.5px solid #5a5a5a;
      border-radius: 10px;
      padding: 6px;
      gap: 8px;
      .line {
        width: 100%;
        height: 1.5px;
        background: #5a5a5a;
      }
      img {
        width: 32px;
        height: 32px;
      }
    }
  }

  .knockContainer.kiosk {
    flex: 1;
    min-height: 100vh;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #000000;
    padding-bottom: 10%;
    .enterButton {
      position: absolute;
      bottom: 10%;
      padding: 20px 60px;
      border: 2px solid #5a5a5a;
      background: #262626;
      border-radius: 50px;
      color: #c1c1c1;
      text-align: center;
      font-size: 28px;
      line-height: 42px;
      font-weight: 300;
      cursor: pointer;
    }
  }
`;
